// import '@fortawesome/fontawesome-svg-core/styles.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

import { createGlobalStyle } from 'styled-components';
import '../scss/style.default.scss';

const GlobalStyles = createGlobalStyle`
  .table-responsive {
    overflow: visible !important;
  }
  .click-disabled {
    pointer-events: none !important;
    opacity: 0.6 !important;
  }
`;

export default GlobalStyles;
